import { Text, Box } from '@chakra-ui/react';
import { ClockIcon } from '@halo/ui-chat-react';
import { useTranslation } from 'react-i18next';

function MessageEncryptedTip() {
  const { t } = useTranslation();
  return (
    <Box
      className="MessageEncryptedTip fadeIn"
      p="3"
      gap="2.5"
      mx="auto"
      bg="green.10"
      borderRadius="md"
      textAlign="center"
    >
      <Box fontSize="1em" mr="6px" as="span" display="inline-block" mb="-1">
        <ClockIcon />
      </Box>
      <Text as="span" fontSize="xs" color="fg" fontWeight="medium">
        {t('chat.messageEncrypted')}
      </Text>
    </Box>
  );
}

const MemoizedMessageEncryptedTip = memo(MessageEncryptedTip);

export { MemoizedMessageEncryptedTip as MessageEncryptedTip };
